/* src/components/datagrid/DataGridSkeleton.jsx */

import { Box, Skeleton } from "@mui/material";

const ROWS = 10;
const COLS = 6;

const DataGridSkeleton = () => {
  return (
    <Box sx={{ p: 1 }}>
      {Array.from({ length: ROWS }).map((_, row) => (
        <Box
          key={row}
          sx={{
            display: "flex",
            gap: 1,
            mb: 1,
          }}
        >
          {Array.from({ length: COLS }).map((_, col) => (
            <Skeleton
              key={col}
              variant="rounded"
              height={32}
              sx={{ flex: 1 }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default DataGridSkeleton;
